import { VAT_CODES } from './vat-codes.js';
export const FR0600_BOXES = [
    { box: '11', label: 'PVM apmokestinami sandoriai' },
    { box: '12', label: 'PVM apmokestinami sandoriai, kai PVM išskaito pirkėjas (96 str.)' },
    { box: '13', label: 'PVM neapmokestinami sandoriai' },
    { box: '14', label: 'Suvartojimas privatiems poreikiams' },
    { box: '15', label: 'Ilgalaikio materialiojo turto pasigaminimas' },
    { box: '16', label: 'Sandorių, kuriems taikoma spec. apmokestinimo schema, marža' },
    { box: '17', label: 'Prekių eksportas (0 proc.)' },
    { box: '18', label: 'ES PVM mokėtojams patiektos prekės (0 proc.)' },
    { box: '19', label: 'Kiti PVM apmokestinami sandoriai (0 proc.)' },
    { box: '20', label: 'Už Lietuvos ribų įvykę sandoriai' },
    { box: '21', label: 'Iš ES įsigytos prekės' },
    { box: '22', label: 'Iš ES įsigytos prekės trikampei prekybai' },
    { box: '23', label: 'Iš užsienio valstybių įsigytos paslaugos' },
    { box: '24', label: 'Iš jų: įsigytos iš ES PVM mokėtojų' },
    { box: '25', label: 'Įsigytų prekių ir paslaugų pirkimo PVM' },
    { box: '26', label: 'Sumokėtas importo PVM' },
    { box: '27', label: 'Importo PVM, kurio įskaitymą kontroliuoja VMI' },
    { box: '28', label: 'Kalendorinių metų proporcinis PVM atskaitos procentas' },
    { box: '29', label: 'Standartinio tarifo pardavimo PVM' },
    { box: '29A', label: '12 proc. pardavimo PVM' },
    { box: '30', label: '9 proc. pardavimo PVM' },
    { box: '31', label: '5 proc. pardavimo PVM' },
    { box: '32', label: 'Pardavimo PVM (95 str.)' },
    { box: '33', label: 'Pardavimo PVM (96 str.)' },
    { box: '34', label: 'Iš ES įsigytų prekių pardavimo PVM' },
    { box: '35', label: 'Atskaitomas PVM' },
    { box: '36', label: 'Mokėtinas (grąžintinas, −) PVM' },
];
const SALES_VALUE = {
    PVM1: '11', PVM58: '11', PVM2: '11', PVM3: '11', PVM25: '12', PVM26: '12', PVM27: '12', PVM5: '13', PVM12: '17', PVM13: '18', PVM50: '18',
    PVM14: '19', PVM51: '19', PVM55: '19', PVM15: '20', PVM19: '20',
    // Own use (PVMĮ 5, 8 str.) and self-built fixed assets (PVMĮ 6 str.).
    PVM6: '14', PVM59: '14', PVM7: '14', PVM8: '14', PVM28: '14', PVM9: '15', PVM30: '15', PVM31: '15',
};
const SALES_VAT = { PVM1: '29', PVM58: '29A', PVM2: '30', PVM3: '31', PVM6: '29', PVM59: '29A', PVM7: '30', PVM8: '31', PVM9: '29', PVM30: '30', PVM31: '31' };
/** The VAT of a self-built fixed asset is input VAT too (box 25). */
const SALES_VAT_DEDUCTIBLE = new Set(['PVM9', 'PVM30', 'PVM31']);
/** Received: [value box(es), the box of the VAT the buyer accounts for]. Domestic VAT charged by the seller goes to 25 only. */
const PURCHASE = {
    PVM1: { value: [], vat: null }, PVM58: { value: [], vat: null }, PVM2: { value: [], vat: null }, PVM3: { value: [], vat: null },
    PVM16: { value: ['21'], vat: '34' }, PVM17: { value: ['21'], vat: '34' }, PVM18: { value: ['21'], vat: '34' },
    PVM19: { value: ['22'], vat: null },
    PVM21: { value: ['23', '24'], vat: '32' }, PVM57: { value: ['23', '24'], vat: '32' }, PVM40: { value: ['23', '24'], vat: '32' },
    PVM20: { value: ['23'], vat: '32' }, PVM54: { value: ['23'], vat: '32' }, PVM37: { value: ['23'], vat: '32' },
    PVM25: { value: [], vat: '33' }, PVM26: { value: [], vat: '33' }, PVM27: { value: [], vat: '33' },
    // A foreign supplier's supply in Lithuania, the buyer accounts for the VAT (PVMĮ 95 str. 4 d.).
    PVM43: { value: [], vat: '32' }, PVM44: { value: [], vat: '32' }, PVM45: { value: [], vat: '32' }, PVM60: { value: [], vat: '32' },
    // Farmers' flat-rate compensation (charged on the invoice).
    PVM49: { value: [], vat: null },
};
/** Received codes with nothing to declare (no deductible VAT): exempt and 0 % purchases. */
const PURCHASE_NONE = new Set(['PVM5', 'PVM14', 'PVM51', 'PVM55', 'PVM35', 'PVM36', 'PVM38', 'PVM39', 'PVM41', 'PVM42', 'PVM46', 'PVM47', 'PVM48', 'PVM32', 'PVM52', 'PVM53', 'PVM33']);
const RATE_CODE = { 2100: 'PVM1', 1200: 'PVM58', 900: 'PVM2', 500: 'PVM3' };
/** Whole euros: 49 cents and less dropped, 50 and more a euro (also for minus amounts). */
export const wholeEuros = (cents) => Math.sign(cents) * Math.floor(Math.abs(cents) / 100 + 0.5);
/**
 * `deduction`: the year's proportional deduction share (box 28, %; 100 when all activity is taxable): the
 * deductible VAT (35) is that share of 25 + 26 + 27. `adjust`: whole euros the accountant adds to boxes the
 * invoices cannot give (margin 16, import VAT 26 and 27, corrections).
 */
export function fr0600(groups, opts = {}) {
    const cents = {};
    const add = (box, v) => { if (v)
        cents[box] = (cents[box] ?? 0) + v; };
    const unmapped = new Map();
    const miss = (direction, code, net) => {
        const k = `${direction}|${code}`;
        unmapped.set(k, { direction, code, net: (unmapped.get(k)?.net ?? 0) + net });
    };
    for (const g of groups) {
        const code = g.code ?? RATE_CODE[g.rate] ?? '';
        if (g.direction === 'outgoing') {
            const box = SALES_VALUE[code];
            if (!box) {
                miss('outgoing', code || '—', g.net);
                continue;
            }
            add(box, g.net);
            if (SALES_VAT[code])
                add(SALES_VAT[code], g.vat);
            if (SALES_VAT_DEDUCTIBLE.has(code))
                add('25', g.vat);
        }
        else {
            if (PURCHASE_NONE.has(code))
                continue;
            const p = PURCHASE[code];
            if (!p) {
                miss('incoming', code || '—', g.net);
                continue;
            }
            for (const box of p.value)
                add(box, g.net);
            if (p.vat) {
                // The buyer accounts for it: the code's rate on the value; deductible as input VAT too.
                const rate = VAT_CODES.find((c) => c.code === code)?.rate ?? 0;
                const vat = Math.round((g.net * rate) / 10_000);
                add(p.vat, vat);
                add('25', vat);
            }
            else
                add('25', g.vat);
        }
    }
    const boxes = {};
    for (const [box, v] of Object.entries(cents))
        if (v)
            boxes[box] = wholeEuros(v);
    for (const [box, v] of Object.entries(opts.adjust ?? {})) {
        if (!v || ['28', '35', '36'].includes(box))
            continue;
        const sum = (boxes[box] ?? 0) + Math.round(v);
        if (sum)
            boxes[box] = sum;
        else
            delete boxes[box];
    }
    const share = Math.min(100, Math.max(0, Math.ceil(opts.deduction ?? 100)));
    const input = (boxes['25'] ?? 0) + (boxes['26'] ?? 0) + (boxes['27'] ?? 0);
    if (boxes['25'] !== undefined || boxes['26'] !== undefined || boxes['27'] !== undefined)
        boxes['35'] = wholeEuros(input * share);
    if (Object.keys(boxes).length)
        boxes['28'] = share;
    const due = ['27', '29', '29A', '30', '31', '32', '33', '34'].reduce((s, b) => s + (boxes[b] ?? 0), 0) - (boxes['35'] ?? 0);
    if (Object.keys(boxes).length)
        boxes['36'] = due;
    return { boxes, unmapped: [...unmapped.values()] };
}
export const FR0600_FORM_DEF_ID = '{0AC6FE8F-6B47-4A22-81C5-8D790D3212B1}';
//# sourceMappingURL=fr0600.js.map